import { AgGridReact } from 'ag-grid-react';
import { useAtomValueRawSync } from 'jotai/react';
import { useMemo } from 'react';

import useGridTheme from '@/hooks/useGridTheme';
import { filteredOrganizationsAtom } from '@/pages/Organizations';

import { useProductDialog } from '../ProductEditDialog';
import OrganizationProductsDetailRenderer from './OrganizationProductsDetailRenderer';
import { COLUMN_DEFS, defaultColDef } from './OrganizationsTable.constants';

const OrganizationsTable = () => {
  const gridTheme = useGridTheme();
  // useAtomValueRawSync (useSyncExternalStore) re-checks after subscribing; the default
  // useAtomValue in Jotai 3 misses atom writes made by SearchBar's mount effect before this subscribes
  const organizations = useAtomValueRawSync(filteredOrganizationsAtom);
  const { openDialog: openProductDialog } = useProductDialog();

  const context = useMemo(() => ({ openProductDialog }), [openProductDialog]);

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <AgGridReact
        rowData={organizations}
        columnDefs={COLUMN_DEFS}
        defaultColDef={defaultColDef}
        theme={gridTheme}
        masterDetail
        isRowMaster={(data) => !!data?.products?.length}
        detailCellRenderer={OrganizationProductsDetailRenderer}
        context={context}
        getRowId={(params) => `${params.data.id}`}
        pagination
        paginationPageSize={25}
        suppressCellFocus
        rowHeight={75}
        detailRowAutoHeight
      />
    </div>
  );
};

export default OrganizationsTable;
